import request from "@/utils/request";

// 获取车辆业务信息
export function getVehicleBusiness(vehicleId) {
  return request({
    url: "/cloud/vehicle/business?vehicleId=" + vehicleId,
    method: "get"
  });
}

// 获取车辆业务订单信息
export function getVehicleBusinessOrders(vehicleId) {
  return request({
    url: "/cloud/vehicle/business/orders?vehicleId=" + vehicleId,
    method: "get"
  });
}